module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-26.c8a8e59a.png";